import React from 'react'
import { Outlet } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

function CatalogManagement() {
  return (
    <Box>
      <Box
        sx={{
          background: '#000869',
          padding: '15px',
          borderRadius: '10px'
        }}
      >
        <Typography variant='h4' color='#fff'>
          Catalog Group Management
        </Typography>
      </Box>

      <Box sx={{ mt: '20px' }}>
        <Outlet />
      </Box>
    </Box>
  )
}

export default CatalogManagement
